module.exports = __webpack_public_path__ + "img/part-4-title.174dfbce.png";